import { useEffect, useState } from 'react'
import { isReady } from '$utils'

/**
 * Hook to check if the app context is ready.
 * Returns a boolean indicating whether the app context is ready.
 *
 * Use this hook in components that need to wait for the app context to be ready
 * before rendering things.
 *
 * @returns {boolean} true if the app context is ready, false otherwise
 */
export function useAppContextReady(): boolean {
  const [appContextReady, setAppContextReady] = useState(false)

  useEffect(() => {
    isReady().then(() => setAppContextReady(true))
  }, [])

  return appContextReady
}
